import { isDesktop,isAndroid, isIOS, isWinPhone, isOpera, mobileVendor,  } from "react-device-detect";

export const findUserDevice = () => {
  if (isDesktop) {
    return "1";
  }
  if (isAndroid) {
    return "2";
  }
  if (isIOS) {
    return "3";
  }
  if (isWinPhone) {
    return "4";
  }
  if (mobileVendor === "BlackBerry") {
    return "5";
  }
  if (isOpera) {
    return "6";
  }
  return "7";
} 